import { HttpClient } from 'shared/libs/http';
import {
   ActionPlanDto,
   ActivateOrDeactivateAllPlansDto,
   ActivatePlanResponse,
   AdminPlanIndexResponse,
   DeactivatePlanResponse,
   DeletePlanResponse,
} from './types';

export class PlansManagerApiService {
   public static async loadPlans<TDto extends null>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<AdminPlanIndexResponse>('/admin/plan/index', dto, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }

   public static async activatePlan<TDto extends ActionPlanDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<ActivatePlanResponse>(
         `/admin/plan/activateplans/${dto.slug}`,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async deactivatePlan<TDto extends ActionPlanDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<DeactivatePlanResponse>(
         `/admin/plan/deactivateplans/${dto.slug}`,
         null,
         {
            headers: {
               adminid: opt.adminID,
               Authorization: `Bearer ${opt.tokenKey}`,
            },
         }
      );
   }

   public static async deletePlan<TDto extends ActionPlanDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      return await HttpClient.post<DeletePlanResponse>(`/admin/plan/deletePlan/${dto.slug}`, null, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }

   public static async activatedAll<TDto extends ActivateOrDeactivateAllPlansDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      dto.action = 'activate';
      return await HttpClient.post<AdminPlanIndexResponse>('/admin/plan/index', dto, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }

   public static async deactivatedAll<TDto extends ActivateOrDeactivateAllPlansDto>(
      dto: TDto,
      opt: { adminID?: string; tokenKey?: string } = {}
   ) {
      dto.action = 'deactivate';
      return await HttpClient.post<AdminPlanIndexResponse>('/admin/plan/index', dto, {
         headers: {
            adminid: opt.adminID,
            Authorization: `Bearer ${opt.tokenKey}`,
         },
      });
   }
}
